function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#1C2154",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 4.963V2.032C16 .913 16.897 0 18 0s2 .913 2 2.032v2.93C20 6.085 19.103 7 18 7s-2-.916-2-2.037z",
  opacity: 0.8
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 34.961v-2.927c0-1.118.897-2.034 2-2.034s2 .916 2 2.034v2.927C20 36.084 19.103 37 18 37s-2-.916-2-2.039z",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.58 10.42c-.773-.776-.773-2.04 0-2.811l2.024-2.025c.778-.779 2.036-.779 2.812 0 .779.78.779 2.033 0 2.807l-2.025 2.03c-.388.384-.898.579-1.405.579-.51 0-1.016-.195-1.407-.58z",
  opacity: 0.9
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.58 31.42c-.773-.774-.773-2.035 0-2.815l2.026-2.024c.782-.775 2.035-.775 2.814 0 .773.781.773 2.035 0 2.814L8.392 31.42c-.386.387-.898.58-1.407.58-.508.001-1.019-.193-1.406-.58z",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.034 20C30.91 20 30 19.104 30 18.001c0-1.105.91-2.001 2.034-2.001h2.93c1.121 0 2.036.901 2.036 2.001C37 19.104 36.085 20 34.964 20h-2.93z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.034 20C.911 20 0 19.106 0 18.001S.911 16 2.034 16h2.932C6.088 16 7 16.901 7 18.001 7 19.104 6.088 20 4.966 20H2.034z",
  opacity: 0.6
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.606 31.42l-2.027-2.03c-.773-.774-.773-2.028.004-2.81.776-.774 2.033-.774 2.81 0l2.026 2.025c.775.78.775 2.041 0 2.815-.39.387-.9.58-1.407.58-.507.001-1.017-.193-1.406-.58z",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.606 10.42L5.579 8.39c-.772-.773-.772-2.032 0-2.806.778-.779 2.036-.779 2.813 0L10.42 7.61c.773.771.773 2.035 0 2.811-.391.385-.898.58-1.406.58-.51 0-1.018-.195-1.408-.58z",
  opacity: 0.7
})));

function SvgIconLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoading);
export default __webpack_public_path__ + "static/media/icon-loading.1917bd14.svg";
export { ForwardRef as ReactComponent };